import Pusher from 'pusher-js';

export const pusher = new Pusher(import.meta.env['VITE_NX_PUSHER_KEY'], { cluster: 'eu' });
